export default "__VITE_ASSET__EATrclIT__"